export default "__VITE_ASSET__D5xf$VW2__"